<template>
   <el-dialog :title="params.title" ref="dialogssRef"
     :visible.sync="params.dialogVisible" :append-to-body="params.isAppendToBody"
     custom-class="subDialog"  :width="params.width" :height="params.height"  @close="()=>{params.close ? params.close() : ''}"
     :close-on-click-modal="false"
     :destroy-on-close="true">
     <div v-if="params.isComponebt  && !params.propData">
        <!-- 动态组件 -->
        <!-- <keep-alive> -->
            <component v-bind:is="params.component" :params="params.data"></component>
        <!-- </keep-alive> -->
     </div>
     <div v-else-if="params.isComponebt && params.propData == 'propData'">
        <!-- 动态组件 -->
        <!-- <keep-alive> -->
            <component v-bind:is="params.component" :propData="params.data"></component>
        <!-- </keep-alive> -->
     </div>
     <div v-else>
        <!-- 详情  编辑  提交？  isShow:false是显示   true是隐藏 -->
        <el-form   :model="ruleForm" :rules="rules" ref="ruleForm" 
            :label-width="params.labelWidth || '100px'" class="demo-ruleForm" 
            :disabled="params.isDisabled"
            >

        <div :class="isInline ? 'formItemWrap' : ''">
            <div  v-for="(item,index) in params.labelList" :class="isInline ? 
            ((item.inputType == 'input_row' || item.inputTypeRow == 'input_row' ) ? 'itemDicv100' : (params.miniSize?'itemDicvMin':'itemDicv')) : ''" :style="item.isShow? 'display:none' : ''">
                <div v-if="!item.isShow">
                    <div v-if="!item.isLabelCustom">
                        <el-form-item  :label="$utils.labelByValue_global(item)" :prop="item.filed"  :label-width="isInline ? (item.labelWidth || '120px') : ( item.labelWidth || '100px') " 
                        :key="index">
                                <inputRuleCon :params="item" :ruleForm="ruleForm"></inputRuleCon>
                        </el-form-item>
                    </div>
                    <div v-else :class="item.className ? item.className : 'labelStyle'">
                        <el-form-item  :label="$utils.labelByValue_global(item)" :prop="item.filed"  :label-width="isInline ?  (item.labelWidth || '120px') : ( item.labelWidth || '100px')" 
                        :key="index">
                                <inputRuleCon :params="item" :ruleForm="ruleForm"></inputRuleCon>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </div>
        <el-form-item>
            <div  style="display: flex;">
                <div  v-if="params.isBtn">
                    <!-- <el-button type="primary" @click="submitForm('ruleForm')">{{ params.submitText || '提交' }}</el-button> -->
                    <el-button type="primary" @click="$utils.debounce(submitForm,500)"
                    :loading="params.isBtnLoading ? true : false">{{ params.submitText || '提交' }}</el-button>
                    <!-- 特殊页面 =》 特殊按钮/ -->
                    <el-button  v-if="params.otherBtn " type="primary" @click="$utils.debounce(submitFormOther,500)">
                        {{params.otherBtn}}</el-button>
                    <el-button v-if="!params.isResetbtn" @click="resetForm('ruleForm')">重置</el-button>
                </div>
                <div v-if="params.downloadBtn" style="margin-left:10px">
                    <el-button  type="primary" @click="$utils.debounce(submitFormDownLoad,500)">{{params.downloadBtn}}</el-button>
                </div>
            </div>
        </el-form-item>
        </el-form>
     </div>
</el-dialog>
</template>

<script>
  import inputRuleCon from '@/components/inputRule'
    export default {
        components: {
            inputRuleCon
        },
        props: {
            params: {
                type: Object,
                default: function(){
                    return {}
                }
            },
        },
        data() {
            return {
                ruleForm:{},
                rules: {
                    // name: [
                    // { required: true, message: '请输入商品名称', trigger: 'blur' },
                    // // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    // ]
                },
                isBtnDisabled:false,
                isInline:false,
            }
        },
        computed: {
        },
        watch:{
            'params.isChangeFiled':{
                handler:function(val,oldVal){
                    // this.ruleForm = this.$utils.getWatchRule(this.params.labelList,this.ruleForm);
                    let valFiled = val.split(",")[1];
                    let echoVal = val.split(",")[2] || "";
                    echoVal = echoVal.toString();
                    if(echoVal){
                        this.ruleForm[valFiled] = echoVal;
                    }else{
                        this.ruleForm[valFiled] = "";
                    }
                    console.log("=============",val,oldVal,this.ruleForm,this.params)
                },
                // deep: true
            },
            'params.isFiledValue':{
                handler:function(val,oldVal){
                    // 动态赋值响应式数据
                    // this.ruleForm = this.$utils.getWatchRule(this.params.labelList,this.ruleForm);

                    // `${val}&&tradeFee&&123`
                    console.log("=============params.isFiledValue",val,oldVal,this.ruleForm,this.params)
                    if(val){
                        let arr= val.split("&&");
                        let filed = arr[1];
                        let filedVal = arr[2] || '';
                        this.ruleForm[filed] = filedVal;
                    }
                },
                // deep: true
            },
        },
        created () {
            console.log("=====gggggggggggg========",this.params)
            let list= this.params.labelList || [];
            this.isInline = list.length > 8 ? true : false
            //type : 1 待验证的input框
            if(this.params.isRequired){
                this.ruleForm = this.$utils.getRule(list);
                for(let item of list){
                    if(item.isRequired){
                        let arr = [];
                        arr.push(
                            {required:true,message:item.placeholder,trigger:'blur'}
                        )
                        this.rules[item.filed] = arr;
                    }
                }
                
            }else{
                if(!this.params.isComponebt){
                    this.ruleForm = this.$utils.getRule(this.params.labelList);
                }
            }
        },
        
        methods: {
            submitForm() {
                console.log("submitqqq",this.ruleForm);
                this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.ruleForm.submitFormOther=0;
                    console.log("submit",this.ruleForm);
                    // this.isBtnDisabled = true;
                    this.$emit("listenDialog",{type:this.params.type,data:this.ruleForm})
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            submitForm_ts() {
                this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    console.log("submit",this.ruleForm,"这是特殊提交");
                    this.ruleForm.submitFormOther=1;
                    this.$emit("listenDialog",{type:this.params.type,data:this.ruleForm})
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            submitFormOther() {
                this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    console.log("submit",this.ruleForm,"这是特殊提交");
                    this.ruleForm.submitFormOther=1;
                    this.$emit("listenDialog",{type:this.params.type,data:this.ruleForm})
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                for(let key in this.ruleForm){
                    this.ruleForm[key] = "";
                }
                //重置图片列表
                for(let item of this.params.labelList){
                    if(item.inputType == 'upload'){
                        item.fileList = [];
                         item.value = "";
                    }
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    //from lable样式变红 
    .labelStyle{
        /deep/ .el-form-item__label{
            font-weight:bold;
            color:red;
        }
    }
    //text_area 禁用文本样式
    .disabledClass{
        /deep/ .el-textarea.is-disabled .el-textarea__inner{
            color:initial !important;
            background: none !important;
        }
    }
  /deep/ .el-form-item{
    margin-bottom: 10px !important;
  }
  .formItemWrap{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .itemDicvMin{
        width: 33%;
    }
    .itemDicv{
        width: 46%;
    }
    .itemDicv100{
        width: 100%;
        min-height:36px
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/dialog/index.vue